const e = (n, t) => {
  const r = t + 1;
  return n === "poi" ? [0, -r - 600] : n === "vtv" ? [0, -r - 500] : n === "thematicDot" ? [0, -r - 400] : n === "poiBoundary" ? [0, -r - 300] : [0, -r];
};
export {
  e as getDeckPolygonOffset
};
//# sourceMappingURL=index.es420.js.map
